import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Fieldset, Legend,Label
} from "reactstrap"
import { ConfirmAlert } from '../../../../helpers/ui/alert'
import { AvForm, AvGroup, AvInput, AvField, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"
import Select from "react-select"
import { Preview,FileInput, generateFormData } from '../../../../helpers/ui/FileInput'

import { Link, useHistory, Redirect } from "react-router-dom"

import apiResponse from '../../../../services/apiResponse'

import ApproveBloc from './Blocs/ApproveBloc'
import DetailBloc from '../Detail/Blocs/DetailBloc'
import PegawaiSideBar from '../../GlobalComponents/PegawaiSidebar'

import { accessRole } from "../../../../helpers/access_role"
import CustomSelect from '../../GlobalComponents/CustomSelect'
import moment from 'moment'

const createYearOption = (startYear = 2000) => {
    var currentYear = new Date().getFullYear(), years = [];
      startYear = startYear || 1980;  
      while ( startYear <= currentYear ) {
          var newObj = {};
          var year = startYear++;
          newObj["label"] = year;
          newObj["value"] = year;
          years.push(newObj);
      }   
      return years;
  }
var reformatRank = function(regions) {
    return regions.map(function(region) {
      var newObj = {};
      newObj["label"] = region.rank_name;
      newObj["value"] = region.rank_uuid;
  
      return newObj;
    });
}
var reformatRankType = function(regions) {
    return regions.map(function(region) {
      var newObj = {};
      newObj["label"] = region.rank_type_name;
      newObj["value"] = region.rank_type_id;
  
      return newObj;
    });
}
var reformatRank = function(regions) {
    return regions.map(function(region) {
      var newObj = {};
      newObj["label"] = region.rank_name;
      newObj["value"] = region.rank_uuid;
  
      return newObj;
    });
  };


  var reformatOptionWorkUnit = function(regions) {
    return regions.map(function(region) {
      var newObj = {};
      newObj["label"] = region.work_unit_name;
      newObj["value"] = region.work_unit_uuid;
      return newObj;
    });
  };

  
class IndexView extends Component {

    approveBloc = new ApproveBloc();
    detailBloc = new DetailBloc()

    // Retrieve Data Pegawai by Admin / Pegawai
    userdata = JSON.parse(localStorage.getItem('userdata'));
    employeeSeleted = JSON.parse(localStorage.getItem('employeeSelected'));
    peg_uuid = !accessRole('approve') ? (this.userdata != null ? this.userdata.employee_uuid : "") 
    : (this.employeeSeleted != null ? this.employeeSeleted.employee_uuid : "")
    peg_nip = !accessRole('approve') ? (this.userdata != null ? this.userdata.employee_nip : "") 
    : (this.employeeSeleted != null ? this.employeeSeleted.employee_nip : "")

    constructor(props) {
        super(props)
        this.state = {
            dataForm: {},
            detail: {},
            logdata: {},
            detaildoc: '',
            logdoc: '',
            rankItems : [],
            ranktypeItems : [],
            rankFormSelected: "",
            yearOptions: createYearOption(new Date().getFullYear() - 100),
            optionStatusApproval : [
                { label: "Disetujui", value: 1 },
                { label: "Ditolak", value: 2 }
              ],
        }
    }

    submitData = async () => {
        const dataForm = generateFormData(this.state.dataForm, 'file')
        await this.approveBloc.fetchApprove(dataForm)
    }

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        this.setState({
            dataForm: {
                peg_nip: this.peg_nip,
              employee_uuid : this.peg_uuid,
              ...values
            },
            confirm: true
        })
    }

    dateParse = (input) =>{
        let res = "-";
        if (input != "" && input != null){
          res = moment(input).format('DD/MM/YYYY')
        }
        return res;
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

    componentDidMount() {
        // console.log(this.employeeSeleted);
        this.approveBloc.approveChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

        this.approveBloc.rankChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        // console.log(response)
                        
                        this.setState({
                            rankItems: reformatRank(response)
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        this.approveBloc.rankTypeChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        // console.log(response)
                        
                        this.setState({
                            ranktypeItems: reformatRankType(response)
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        this.detailBloc.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        this.setState({
                            detail: response,
                            detaildoc:response?.document_sk?.documents_path
                        })
                        console.log(response.document_sk)
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        this.detailBloc.logChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        this.setState({
                            logdata: response,
                            logdoc:response?.document_sk?.documents_path
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        const queryParams = new URLSearchParams(window.location.search)
        this.detailBloc.fetchDetail({uuid: queryParams.get('uuid') })
        this.detailBloc.fetchLogDetail({uuid: queryParams.get('uuid') })
       
        this.approveBloc.fetchRank()
        this.approveBloc.fetchRankType()

    }

    

    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">

                            <PegawaiSideBar active="riwayat_pangkat"/>

                            <Card className="pegawai-rightbar">
                                <CardBody>
                                    <CardTitle>Approve Riwayat Pangkat</CardTitle>
                                    <CardSubtitle className="mb-3">
                                        {/* Setiap isian yang bertanda () adalah wajib diisi. */}
                                    </CardSubtitle>
                                    <hr />
                                    <AvForm
                                        className="needs-validation"
                                        onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                                    >
                                        {(this.state.logdata)?
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                            &nbsp; 
                                            </label>
                                                    
                                            <label
                                                htmlFor="name"
                                                className="col-md-5 col-form-label"
                                            >
                                            Data Baru 
                                            </label>        
                                            <label
                                                htmlFor="name"
                                                className="col-md-4 col-form-label text-danger"
                                            >
                                            Data Lama 
                                            </label>        

                                        </Row>:''
                                        }
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                            Pangkat 
                                            </label>
                                                    
                                            <Col md="5">
                                            <AvField
                                                name="uuid"
                                                type="hidden"
                                                value={this.state.detail.rank_history_uuid}
                                            />
                                            {this.state.detail.rank_name}
                                            </Col>        
                                            <Col md="4">
                                            {this.state.logdata?.rank_name}
                                            </Col>        

                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                            Tipe Pangkat 
                                            </label>
                                                    
                                            <Col md="5">
                                            {this.state.detail.rank_history_rank_type}

                                            </Col>        
                                            <Col md="4">
                                            {this.state.logdata?.rank_history_rank_type}

                                            </Col>        

                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Masa Kerja Tahun 
                                            </label>
                                            <Col md="5">
                                                {this.state.detail.rank_history_year_period}
                                            </Col>
                                            <Col md="4">
                                                {this.state.logdata?.rank_history_year_period}
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Masa Kerja Bulan 
                                            </label>
                                            <Col md="5">
                                                {this.state.detail.rank_history_month_period}
                                            </Col>
                                            <Col md="4">
                                                {this.state.logdata?.rank_history_month_period}
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            No SK 
                                            </label>
                                            <Col md="5">
                                                {this.state.detail.rank_history_decree_number}
                                            </Col>
                                            <Col md="4">
                                                {this.state.logdata?.rank_history_decree_number}
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                            Tanggal SK 
                                            </label>
                                            <Col md="5">
                                                {this.state.detail?.rank_history_decree_date?this.dateParse(this.state.detail?.rank_history_decree_date):''}
                                            </Col>
                                            <Col md="4">
                                                {this.state.logdata?.rank_history_decree_date?this.dateParse(this.state.logdata?.rank_history_decree_date):''}
                                            </Col>
                                        </Row>

                                        {/* <Row className="mb-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                            Nama Jabatan 
                                            </label>
                                            <Col md="5">
                                                <Select
                                                    value={this.state.positionItems.filter(option => 
                                                      option.value === this.state.PositionSelected)}
                                                    onChange={
                                                      this.onChangePosition
                                                    }
                                                    required="required"
                                                    options={this.state.positionItems}
                                                    classNamePrefix=""
                                                />

                                                <AvField
                                                    name="position_id"
                                                    placeholder="Nama Jabatan..."
                                                    type="hidden"
                                                    errorMessage="Masukkan Nama Jabatan"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="position_id"
                                                    value={this.state.PositionSelected}
                                                />
                                            </Col>
                                        </Row> */}

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                            TMT Jabatan 
                                            </label>
                                            <Col md="5">
                                                {this.state.detail?.rank_history_tmt_date?this.dateParse(this.state.detail?.rank_history_tmt_date):''}
                                            </Col>
                                            <Col md="4">
                                                {this.state.logdata?.rank_history_tmt_date?this.dateParse(this.state.logdata?.rank_history_tmt_date):''}
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                className="col-md-3 col-form-label"
                                            >
                                                Download File SK KP 
                                            </label>
                                            <Col md="5">
                                            {this.state.detaildoc?<a href={this.state.detaildoc} className='btn btn-success' target={'_blank'} download><i class="uil-download-alt"></i> {this.state.detail?.document_sk?.documents_name}</a>:'-'}
                                            </Col>
                                            <Col md="4">
                                            {this.state.logdoc?<a href={this.state.logdoc} className='btn btn-success' target={'_blank'} download><i class="uil-download-alt"></i> {this.state.logdata?.document_sk?.documents_name}</a>:'-'}
                                            </Col>
                                        </Row>
                                        
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Status Approval <span className="text-danger">*</span>
                                            </label>
                                            <Col md="3">
                                                <CustomSelect 
                                                    name="status_approval"
                                                    errorMessage="Pilih Status Approval"
                                                    options={this.state.optionStatusApproval} 
                                                    placeholder="Pilih Status Approval"
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="status_approval_description"
                                                className="col-md-3 col-form-label"
                                            >
                                            Keterangan Approval <span className="text-danger">*</span>
                                            </label>
                                            <Col md="9">
                                                <AvField
                                                    name="status_approval_description"
                                                    placeholder="Keterangan Approval..."
                                                    type="textarea"
                                                    errorMessage="Masukkan Keterangan Approval"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="status_approval_description"
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <Col md="3"></Col>
                                            <Col md="9">
                                                <Link to="/kepegawaian/home.html?riwayat_pangkat">
                                                    <Button color="danger"><i className="uil-arrow-left"></i> Kembali</Button>
                                                </Link>
                                                {' '}
                                                <Button color="success" type="submit">
                                                    <i className="uil-arrow-up-right"></i> Simpan Data
                                                </Button>
                                            </Col>
                                        </Row>
                                    </AvForm>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menyimpan data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.redirect ?
                    <Redirect to='/kepegawaian/home.html?riwayat_pangkat'/>
                : null }
            </Fragment>
        )
    }

}

export default IndexView